export default {
  changeScreenSize(state, screenSize) {
    state.screenSize = screenSize
  },
  changeSidebarOpened(state, sidebarOpened) {
    state.sidebarOpened = sidebarOpened
  },
  changeGoodsFiltersOpened(state, opened) {
    state.goodsFiltersOpened = opened
  },
  changeGoodsFiltersActiveTab(state, activeTab) {
    state.goodsFiltersActiveTab = activeTab
  },
  changeFooterHeight(state, newHeight) {
    state.footerHeight = newHeight
  },
  changeLoadingModalParams(state, params) {
    state.loadingModalParams = params
  },
  SET_BANNER(state, bannerParams) {
    state.banner = bannerParams
      ? {
          ...bannerParams,
          hasAnimated: false,
        }
      : null
  },
  SET_BANNER_ANIMATED(state, value) {
    if (!state.banner) {
      return
    }
    state.banner.hasAnimated = value
  },
}
